import * as React from 'react';

import { Box } from '~shared/components/Box';

import { UseIconProps, useIcon } from '../../useIcon';
import { IconShieldSlashSvg } from './IconShieldSlashSvg';

export type IconShieldSlashProps = UseIconProps;

export function IconShieldSlash(props: IconShieldSlashProps) {
  const iconProps = useIcon(props);

  return <Box tagName={IconShieldSlashSvg} {...iconProps} />;
}
